import { useState } from "react";
import { useReactToPrint } from "react-to-print";

const usePrint = (componentRef, fileTitle) => {
  const [loading, setLoading] = useState(false);

  const action = useReactToPrint({
    onAfterPrint: () => setLoading(false),
    content: () => componentRef.current,
    documentTitle: fileTitle,
  });

  const printFile = async () => {
    setLoading(true);
    setTimeout(() => {
      action();
      setLoading(false);
    }, 0);
  };

  return { loading, printFile };
};

export default usePrint;
